import { render } from "./submission-panel-supporter-contacts.vue?vue&type=template&id=2b69d647&scoped=true&ts=true"
import script from "./submission-panel-supporter-contacts.vue?vue&type=script&lang=ts"
export * from "./submission-panel-supporter-contacts.vue?vue&type=script&lang=ts"

import "./submission-panel-supporter-contacts.vue?vue&type=style&index=0&id=2b69d647&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b69d647"]])

export default __exports__